module.exports = __webpack_public_path__ + "img/1.12b7bca6.png";